import React, { Component } from "react";
import { Row, Col } from "reactstrap";

import TextBox from "../Helper/TextBox";

export default class Jumbo extends Component {
  render() {
    return (
      <Row>
        <Col>
          <Row
            width="100%"
            className="row"
            style={{
              marginTop: 45,
              padding: 40,
              paddingBottom: 20,
              paddingTop: 75,
              backgroundColor: "white",
              color: '#024563'
            }}
          >
            <Col style={{backgroundColor: "white"}}>
              <h1 style={{paddingLeft: "4%"}}>{this.props.title}</h1>
              <h4 style={{color: "#0691d1", paddingLeft: "4%"}}>{this.props.ticker}</h4>
            </Col>
          </Row>
          <Row>
            <Col
              style={{
                backgroundColor: "white",
                padding: "20px 55px",
              }}
            >
              <h4 style={{color: '#024563',paddingLeft: "4%"
              }}>
                Objective: {this.props.objective}
              </h4>
              <hr style={{marginLeft: '4%', marginRight: "6%", borderWidth: "3px", borderColor: "orange", opacity:90}}></hr>
              <Row style={{color:"#696a6b", paddingLeft: "4%", paddingRight: "5%"}}>
                {this.props.descriptions.map((pair) => (
                  <TextBox heading={pair[0]} text={pair[1]} />
                ))}
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    );
  }
}
